enum MimeType {
  PDF = 'application/pdf',
  OCTET_STREAM = 'application/octet-stream',
}

export { MimeType };
